const initialState = {
    statusShow: false,
    tabSelect: 'login',
    phoneNumber: '',
    disabledBtn: true,
    timer_time: 0,
    code: '',
    loaderGetPssLogin: false,
    loaderFinalLogin: false,
    introduced_code: '',
};
const modalLoginAndRegister = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_LOGIN_AND_REGISTER':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_LOGIN_AND_REGISTER':
            return {...state, statusShow: false};
        case 'CHANGE_TAB_SELECT_MODAL_LOGIN_AND_REGISTER':
            return {...state, tabSelect: action.tabSelect};
        case 'CHANGE_INPUT_MODAL_LOGIN_AND_REGISTER':
            return {...state, [action.name]: action.value};
        case 'CHANGE_INPUTS_BASE_MODAL_LOGIN_AND_REGISTER':
            return {...state, phoneNumber: action.phoneNumber, code: action.code};
        case 'CHANGE_DISABLED_BTN_LOGIN_AND_REGISTER':
            return {...state, disabledBtn: action.disabledBtn};
        case 'CHANGE_TIMER_TIME_LOGIN_AND_REGISTER':
            return {...state, timer_time: action.timer_time};
        case 'CHANGE_LOADER_GET_PASS_LOGIN_AND_REGISTER':
            return {...state, loaderGetPssLogin: action.loaderGetPssLogin};
        case 'CHANGE_LOADER_FINAL_BTN_LOGIN_AND_REGISTER':
            return {...state, loaderFinalLogin: action.loaderFinalLogin};
        case 'CHANGE_RESTART_FORM_LOGIN_AND_REGISTER':
            return initialState;
        default:
            return state;
    }
};

export default modalLoginAndRegister;